export default __webpack_public_path__ + "static/media/1.1.2.6549a553.png";